import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class BlogFilterService {
    constructor(private http: HttpClient) { }

    getBlogFilterService() {
        return this.http.get<any[]>(`${environment.apiUrl}blog-filters`);
    }
	
     
}